import React, { useState } from "react";
import api, { apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Plus, Check, X } from "lucide-react";
import { toast } from "sonner";

const NONE = "__none__";

export function ProjectCategorySelect({ value, onChange, cats, setCats, canCreate, personal = false }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState("");
  const create = async () => {
    if (!name.trim()) return;
    try {
      const { data } = await api.post("/project-categories", { name: name.trim(), personal });
      setCats([...cats, data]); onChange(data.id); setAdding(false); setName("");
      toast.success("Category created");
    } catch (e) { toast.error(apiError(e)); }
  };
  if (adding) return (
    <div className="flex gap-1.5" data-testid="project-category-create-inline">
      <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="New category name" autoFocus className="h-9"
        onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); create(); } }} data-testid="project-category-new-name" />
      <Button type="button" size="sm" variant="outline" onClick={create} data-testid="project-category-new-save"><Check className="w-4 h-4" /></Button>
      <Button type="button" size="sm" variant="ghost" onClick={() => setAdding(false)}><X className="w-4 h-4" /></Button>
    </div>
  );
  return (
    <div className="flex gap-1.5">
      <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? null : v)}>
        <SelectTrigger className="h-9" data-testid="project-category-select"><SelectValue placeholder="Uncategorized" /></SelectTrigger>
        <SelectContent className="bg-white max-h-64">
          <SelectItem value={NONE}>Uncategorized</SelectItem>
          {cats.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      {canCreate && <Button type="button" size="sm" variant="outline" className="h-9 whitespace-nowrap" onClick={() => setAdding(true)} data-testid="project-category-create-btn"><Plus className="w-4 h-4 mr-1" />Create Category</Button>}
    </div>
  );
}
